import {
  DsBadge,
  DsButton,
  DsCard,
  DsEmptyState,
  DsInput,
  DsPrice,
  DsSectionHeader,
  DsSkeleton
} from "@corporatesclub/ui";

export function DesignSystemPage() {
  return (
    <div className="content">
      <div className="inside" style={{paddingBottom: 64}}>
        <DsSectionHeader title="Design System — Etapa 1" />
        <p style={{margin: "0 0 32px 0", color: "var(--cc-ds-color-muted)", fontSize: "var(--cc-ds-font-sm)"}}>
          Pachet <code>@corporatesclub/ui</code> — tokeni Bixoto + 8 primitive. Pagină de verificare internă.
        </p>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Buttons" />
          <div style={{display: "flex", flexWrap: "wrap", gap: 12}}>
            <DsButton variant="primary">Primary</DsButton>
            <DsButton variant="secondary">Secondary</DsButton>
            <DsButton variant="outline">Outline</DsButton>
            <DsButton variant="ghost">Ghost</DsButton>
            <DsButton variant="primary" size="sm">Small</DsButton>
            <DsButton variant="primary" size="lg">Large</DsButton>
            <DsButton variant="primary" disabled>Disabled</DsButton>
          </div>
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Input" />
          <div style={{maxWidth: 360}}>
            <DsInput label="Email" placeholder="name@company.ro" hint="Folosit pentru notificări comenzi" />
            <div style={{height: 16}} />
            <DsInput label="Cod eroare" placeholder="..." error="Câmp obligatoriu" />
          </div>
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Badges" />
          <div style={{display: "flex", flexWrap: "wrap", gap: 8}}>
            <DsBadge>Default</DsBadge>
            <DsBadge variant="primary">Primary</DsBadge>
            <DsBadge variant="sale">-18%</DsBadge>
            <DsBadge variant="success">Disponibil</DsBadge>
            <DsBadge variant="warning">Stoc limitat</DsBadge>
          </div>
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Card" />
          <div style={{maxWidth: 420}}>
            <DsCard title="Card titlu">
              <p className="cc-ds-card__text">Conținut card cu shadow și border conform tokenilor DS.</p>
            </DsCard>
          </div>
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Price" />
          <DsPrice current="48,50 Lei" old="59,24 Lei" saveLabel="Economisești 10,74 Lei (18%)" sale />
          <div style={{height: 16}} />
          <DsPrice current="12,99 Lei" />
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Section header" actionLabel="Vezi toate" actionHref="/all" />
        </section>

        <section style={{marginBottom: 40}}>
          <DsSectionHeader title="Skeleton" />
          <DsSkeleton variant="title" />
          <DsSkeleton variant="text" />
          <DsSkeleton variant="text" width="80%" />
          <DsSkeleton variant="block" />
        </section>

        <section>
          <DsSectionHeader title="Empty state" />
          <DsCard>
            <DsEmptyState
              icon={<i className="fa fa-shopping-bag" aria-hidden="true" />}
              title="Coșul este gol"
              description="Adaugă produse din catalog pentru a continua."
              actionLabel="Explorează catalogul"
              actionHref="/all"
            />
          </DsCard>
        </section>
      </div>
    </div>
  );
}
